import { Link } from "react-router-dom";
import { useState } from "react";

import classes from "./css/ShowCard.module.css";

const ShowCard = (props) => {
  const [isHover, setIsHover] = useState(false);

  return (
    <Link
      to={`/shows/${props.id}/${props.title}`}
      className={classes.main}
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => {
        setIsHover(false);
      }}
      key={props.id}
      state={{
        date: props.date,
        title: props.title,
        author: props.author,
        description: props.description,
        wrap_text: props.wrap_text,
        image_main: props.image_main,
        image_one: props.image_one,
        image_two: props.image_two,
        image_three: props.image_three,
        image_four: props.image_four,
        image_five: props.image_five,
        image_six: props.image_six,
      }}
      style={{ backgroundImage: `url(${props.image_main})` }}
    >
      <div
        className={classes.info_show_container}
        style={{
          height: `${isHover ? "100%" : "45%"}`,
          transition: "0.4s ease",
        }}
      >
        <p>{props.author}</p>
        <h2>{props.title}</h2>
        <p>{props.date}</p>
      </div>
    </Link>
  );
};

export default ShowCard;
